/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CacheEntrySchema } from './CacheEntrySchema';
import {
    CacheEntrySchemaFromJSON,
    CacheEntrySchemaFromJSONTyped,
    CacheEntrySchemaToJSON,
} from './CacheEntrySchema';

/**
 * 
 * @export
 * @interface PagedCacheEntrySchema
 */
export interface PagedCacheEntrySchema {
    /**
     * 
     * @type {Array<CacheEntrySchema>}
     * @memberof PagedCacheEntrySchema
     */
    items: Array<CacheEntrySchema>;
    /**
     * 
     * @type {number}
     * @memberof PagedCacheEntrySchema
     */
    count: number;
}

/**
 * Check if a given object implements the PagedCacheEntrySchema interface.
 */
export function instanceOfPagedCacheEntrySchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function PagedCacheEntrySchemaFromJSON(json: any): PagedCacheEntrySchema {
    return PagedCacheEntrySchemaFromJSONTyped(json, false);
}

export function PagedCacheEntrySchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): PagedCacheEntrySchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(CacheEntrySchemaFromJSON)),
        'count': json['count'],
    };
}

export function PagedCacheEntrySchemaToJSON(value?: PagedCacheEntrySchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(CacheEntrySchemaToJSON)),
        'count': value.count,
    };
}

